export const title = "CF Global";
export const registered = {
    accountType: "Real A/C",
    accountTitle: "Register Account",
    registered: "Register Now",
    explain: "I am over 18 Years old and agree to TREX's Privacy Policy",
    successTitle: "Register Successful",
    successTxt: "You can go to the user center to activate TREX and MT4 account",
    goPosition: "Trade",
    questionTit: "How to get bonus?",
    questionStep1: "First step",
    questionTxt1: "Login user center",
    questionStep2: "Second step",
    questionStep3: "Third step",
    questionTxt3: "Contact to take bonus",
    questionStep4: "Fourth step",
    questionTxt4: "Trade and take bonus",
    invalidTxt: "Please enter a true phone number",
    invalidPwdTxt1: "Password cannot be null!",
    invalidPwdTxt2: "Password shall be 5-15 characters with a mix of letters and numbers!",
};
export const login = {
    language: 'Language',
    account: 'Phone',
    password: 'Password',
    accountPlace: 'Please enter your phone or your account',
    passwordPlace: 'please enter your password',
    submit: 'Login',
    rigister: "Don't have an account yet？",
    forget: 'Forget password',
    openAcc: "Open a account",
    logging: 'Logging in',
    accountNull: 'Your user account is none',
    pwNull: "Your password is none",
    goLogin: 'Go to log in',
    openAccount: 'Register now',
    countrySearch: 'Country Name/Region Code',
    curCountry: 'Current region code',
    countrySelect: 'Select other country code',
    getCode: 'Verify code',
    codePlace: 'Please enter code',
};
export const trade = {
    navigate: {
        recharge: 'Deposit',
        activity: 'Activity Center',
        transaction: 'Reports',
        online_service: 'Service Online',
        knowledge: "For beginners",
        withdrawal: "Withdrawal"
    },
    tab: {home: 'Home page', position: 'Transaction', market: 'Position', me: 'Mine'},
    noData: {
        content: 'Network loading is slow, please refresh and try again',
        reload: 'Loading again',
        noData: "Haven't date yet!",
        noLogin: "You haven't log in, please log in and read more!",
        goPosition: 'Go to trade',
    },
    bannerTitle: 'Recommend with gifts',
    bottom: {
        explain: "Leading Forex Trading Platform",
        login: 'Login/Register'
    },
    openIM: 'Service Online',
    goHome: 'Back to home page',
    token: "Syncing log-in status...",
    turn: 'Date is loading...',
    loading: 'Date is loading...',
    charts: {
        timeSharing: 'Time',
        fiveM: '5m',
        fifteenM: '15m',
        thirtyM: '30m',
        OneH: '1h',
        day: 'Day',
        time: "Time",
        opens: 'Open',
        highs: 'High',
        lows: 'Low',
        receipts: 'Take'
    },
    products: {
        aboutNews: 'News related',
        tradeProduct: 'Symbol',
        type: 'Type',
        notSet: "Haven't set up",
        ask: 'Ask',
        bid: 'Bid',
        newP: 'Newest price',
        rate: "Up-down range",
        rise: 'Up',
        buy: 'Buy',
        fall: 'Down',
        sell: 'Sell',
        open: 'Open',
        high: 'High',
        low: 'Low',
        newPs: 'Close',
        day: 'Today',
        dayWeek: 'Effective on day',
        week: 'Week',
        validWeek: 'Effective in week',
        marketPrice: 'Market price',
        pendingOrder: 'Limit Order',
        modifyPendingOrder: 'Alter limit order',
        positionOrder: 'Position',
        limitPrice: 'Limit price',
        justLoss: 'Stop loss',
        amount: 'Investment funds',
        lot: 'Lot',
        price: 'Price',
        money: 'Funds',
        minAmount: 'Min amount',
        stopLossSwitch: 'SL/TP',
        modifyStopLoss: 'Alter stop loss-take profit',
        stopProfit: 'Take profit',
        stopProfitPrice: 'Take profit price',
        stopLoss: 'Stop loss',
        stopLossPrice: 'Stop loss price',
        expectedProfit: 'Expected profit',
        expectedLoss: 'Expected loss',
        validityPeriod: 'Validity date',
        reference: 'Reference Margin',
        available: "Funds can be used",
        expectedProfitLoss: "Expected profit-loss",
        floatProfitLoss: 'Floating profit-loss',
        realTimeProfitLoss: 'Profit-loss live',
        finalPrice: 'Trading Price',
        openingPosition: 'Open a position',
        closePosition: 'Close a position',
        openingBuy: 'Open/buy',
        openingSell: 'Open/sell',
        executeBuy: 'Close/buy',
        executeSell: 'Close/sell',
        marketPriceSuc: 'Market-price trade',
        limitPriceSuc: 'Limited trade',
        justLossSuc: 'S/L Trade',
        stopLossExecute: 'Close to stop loss',
        stopProfitExecute: "Close to take profit",
        systemExecute: "System close",
        groupClose: 'Close and transaction',
        tradeRecord: 'Check transaction history',
        entrustRecord: 'Check limit order history',
        profitAndLossRecord: 'Check profit-loss history',
        creditRecord: 'Check capital change history',
        withdrawal: 'Cancel order',
        transactionDay: 'transactionDay',
        ProfitLossDay: 'P/L',
        more: 'More',
        rangeScope: 'Max Dev',
        marginUsage: 'Margin Usage',
        availableMargin: 'Available Margin'
    },
    attribute: 'Contract specification',
    unit: "Contract Unit",
    baseCurrency: 'Currency',
    incomeCurrency: 'Currency take profit',
    quoteDigits: 'Quote Digits',
    spread: 'Spread',
    float: 'Floating',
    singleTrade: 'Single trade pips',
    minDistant: 'Minimum pending order distant',
    singlePip: 'Distant of a single pip',
    initialMargin: 'Initial Margin',
    holidayMargin: 'Holiday Margin',
    hedgingMargin: "Hedging Margin",
    three_day: '3-day Swaps',
    tradingHours: 'Trading Hours',
    expiryTime: 'Expiry Time',
    USD: 'USD',
    lot: 'lot',
    amountRange: "Investment amount range",
    totalOrder: 'of the total hedging margin',
    requirement: 'Margin requirement',
    expirationTime: 'Contract expiration time',
    DayOfWeek: {
        monday: 'Mon',
        tuesday: ' TUE',
        wednesday: 'Wed',
        thursday: ' THU',
        friday: 'FRI',
        saturday: 'SAT',
        sunday: 'SUN',
        everyday: ' Everyday'
    }
};
export const recharge = {
    feeInfo: 'About the fee',
    feeExplain: "Tips: Please be sure to select the available denomination amount of the recharge card you purchased, otherwise the funds will not be successfully received",
    recharge_success: 'Congratulations on your successful recharge',
    recharge_fail: 'There is a problem with recharge, you can try again.',
    toConfirm: 'to be confirmed',
    pend: 'Pending',
    approve: 'Approved',
    succ: 'Successful deposit',
    cancle: 'Cancelled',
    over: 'Overdue',
    noUpload: 'Haven’t uploaded credentials',
    Replenishment: 'Transfer receipts',
    rechargeWay: 'Payment gateway',
    cardPay: 'Point card payment',
    seller: 'Operator',
    cardMoney: 'Card denomination(VND)',
    rechargeMoney: ' Deposit denomination(VND)',
    fee: 'Fee（VND）',
    againCon: 'Please confirm the card info again',
    cardNum: 'The card number',
    password: ' The payment password',
    typeNum: 'Please type in the card number',
    typePassword: 'Please type in the recharge password',
    payNow: 'Pay now',
    cardText: 'The card number of the prepaid card you purchased',
    passwordText: 'The recharge password of the prepaid card you purchased',
    transferCopy: 'Copy',
    transferSucc: 'copy success',
    goCharge: 'Deposit',
    details: "Details",
    transferNotice: 'Important Notice',
    transferDeposit: 'Deposit Amount',
    tranferDe: 'Deposit Details',
    supplyNum: 'Application number',
    rechargeMethod: 'Deposit method',
    rechargeTime: 'Deposit time',
    transferBank: 'Benificary Bank',
    transferAdd: 'Branch Address',
    transferReci: 'Recipient',
    transferAcc: 'Recipient Account',
    transferNote: 'Transfer Notes',
    deposited: "I have deposited",
    onlinebank: 'internet Bank',
    atm: "ATM",
    counterDeposit: ' Counter Deposit',
    other: 'Other',
    rechargeAcc: 'Deposit Account',
    arrival: 'Amount of arrival',
    rechargeSucc: 'The recharge certificate is submitted successfully and the system will process it as soon as possible',
    trade: 'Experience transaction',
    checkRecode: 'View recorded',
    copyMessages: "The browser not supporting copy automatically",
    amountPlaceholder: "Please enter amount",
    minAmountVND: "Minimum deposit",
    minAmountUSD: "Minimum",
    tranferNoticeDetail: 'You are advised to compelet the deposit process within 60 minutes, otherise,  your order may be expired.In order to ensure that the deposit arrives smoothly, please make sure that the actual transfer amount is the same as the deposit amount! (Remarks transaction fee)',
    submitTransferInfo: 'In order to ensure the funds arrive quickly, please be sure to return to this page or recharge record after the transfer is successful to supplement the recharge credentials',
    radio: 'The current real-time exchange rate is',
    pre: 'and it is estimated that',
    detail: 'which is subject to actual arrival',
    rechargeTxt:"Each max deposition amount : 999999900.00 VND"
};
export const myself = {
    clickLogin: 'Click and register',
    uncomplate: 'Uncompleted data',
    underReview: 'under review',
    complate: 'Completed data',
    fali: 'Audit failure',
    balance: "My balance(USD)",
    withdrawRecode: 'Historic Data',
    recharge: 'Deposit',
    withdrawal: 'Withdraw',
    setPassword: 'Password manage',
    myBankCard: 'My bank card',
    add: 'Add',
    addBankCard: 'Add a bank card',
    tradeReport: 'Reporting history',
    messageCenter: 'News center',
    openIM: 'Contact with Service',
    deleteUser: 'Exit',
    bankPopup: "For the security of your funds, withdrawal requires real-name authentication and binding of bank cards！",
    realName: 'Go to real name',
};
export const message = {
    point: "Tips",
    submit: 'Submit',
    submitting: 'Submitting',
    cancel: 'Cancel',
    definite: 'OK',
    register: 'Log back in',
    info_register: 'Sorry, this account has logged-in on other device!',
    info_tokenErr: "Login information out of time",
    modify: 'Affirm to change',
    definiteClosing: 'Affirm to close',
    info_withdrawal: 'Are you sure want to cancel this order？',
    withdrawalSuc: 'Cancel successful',
    info_noLogin: 'Dear customer, visitors can not trade, if you need more service, please register or log-in, thanks',
    modifyStopLoss: {
        noModification: 'No parameters have been changed, please submit after you changing',
        stopLossNoRange: 'The stop loss you enter is no in range, please in-enter',
        stopProfitNoRange: 'The take-profit you enter is no in range, please in-enter',
        priceNoRange: 'The price you enter is no in range, please in-enter',
        amountNoRange: 'The amount you enter is out of range, please try again',
        insufficientFunds: "Your avaliable capital amount is insufficient, please deposit first",
        maxAmount: 'Max amount can be invested is',
        integerAmount: "The number entered needs to be an integer multiple of"
    },
    insufficientBalance: "Dear customer, you balance is no sufficient",
    insufficientBalance_1: 'To not ensure save for you trading, please supplement capital in-time',
    poorNetwork: 'Server error, please try again',
    info_dome: "Sorry, you need to login your real account to operate.",
    info_dome1: "Please switch to real account so that you can deposit and trade",
    accountSwitch: "Switch to real account",
    demo: "Demo",
    real: " Real",
    experienceDemo: 'Experience demo'
};
export const success = {
    success: 'Success',
    congratulation: 'Congratulation',
    infoTit_1: 'Congratulation! Stop loss and take profit have been change successful！',
    infoTit_2: 'Congratulation! You have close the order！',
    viewPositions: 'Check position',
    viewRecord: 'Check history',
    viewProfitLoss: 'Check P&L',
    startTrading: 'Start trading',
    positionID: 'Position number',
    orderID: "Order number",
    pendingID: 'Limit-order number',
    positionPro: 'Symbol have bought',
    pendingPro: 'Limit-order Symbol',
    executePrice: 'Close price',
    openingPrice: 'Open price',
    openingTime: 'Open time',
    pendingPrice: 'L-order price',
    pendingTime: 'Limit order time',
    productDirection: 'Symbol direction',
    executeDirection: 'Close direction',
    openingDirection: 'Open direction',
    pendingDirection: 'Limit-order direction',
    executeAmount: 'Close capital',
    profitLoss: 'Loss-profit',
    swap: 'Overnight rate',
    interest: 'Rate',
    commission: 'Margin',
    netProfitLoss: 'Net loss-profit',
    marketOpening: 'Open with market price',
    pendingModify: 'Change limit-order',
    pendingType: 'Limit-order type',
    pageExpired: 'The page have been inefficacy',
};
export const webUiError = {
    negativeOne: "Parameter is inefficacy",
    error1: 'Password error',
    error2: 'Please enter the correct verification code',
    error4: 'No operation permission',
    error5: 'Operating loss',
    error12: 'The user have been existed',
    error13: 'Please enter the correct account number',
    error14: 'Sorry, this account have been logged-in other device!',
    error15: 'The demo account have out of the date, please register an real account',
    error16: 'Please enter the correct user account number',
    error17: 'The user have been existed',
    error18: 'Sorry, this account have been logged-in',
    error19: 'The server is out of connecting, please try again',
    error24: 'No related history yet',
    error38: 'Sorry, server buy, please retry later',
    error39: 'The margin is insufficient, for not affect to the transaction, please supplement capital in time',
    error50: 'Market for reference, do not offer trading service',
    error54: 'The server is dealing with it, please wait for a moment',
    error55: 'The order have been traded',
    error56: 'The order state is error',
    error59: 'Trading success',
    error62: 'The price have changed, please re-order',
    error64: 'Have over the efficacious pips for every single order',
    error65: 'Below the the efficacious pips for every single order',
    error67: 'Closing pips have over the hold position pips',
    error70: 'No position to close',
    error73: 'The point change range of the max-price',
    error74: 'Sorry, the pips have over the position',
    error75: 'No trading time, operating is noneffective',
    error83: 'Max orders {0}',
    error87: 'This account abnormal, please contact with service online',
    error89: 'Please enter the effective pips . The effective pips should be the integral multiple of {0}',
    error94: 'The symbol have temporary stop trading',
    error96: 'The account can only close position, if any question, please contact our service online',
    error103: 'Over the upper limit of holding position',
    error104: 'The symbol have been out of date',
    error107: 'Stop loss and take profit setting is error',
    error108: 'The symbol can only closing position operation, if any question, please contact with service online',
    error110: 'Server busy, please entry later',
    error112: 'Non-privileged'
};
export const category = {
    Commodites: "Commodites",
    Forex: "Forex",
    Index: "Index",
    USStock: "USStock",
    HKStock: "HKStock",
    Crypto: "Crypto"
};